export default __webpack_public_path__ + "static/media/firstPosition.498308ae.svg";